import { useEffect, useState } from 'react';
import { useGameStore } from '@/store/gameStore';
import { GAME_CONFIG } from '@/types';
import { hotRollsText, hotRollsBg, hotRollsStripe } from '@/assets/ui';

export default function HotRollsBanner() {
  const { hotRollsEndTime, isHotRollsActive } = useGameStore();
  const [timeLeft, setTimeLeft] = useState(GAME_CONFIG.HOT_ROLLS_DURATION / 1000);
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    if (!isHotRollsActive || !hotRollsEndTime) {
      setIsVisible(false);
      return;
    }
    
    // Анимация появления
    setTimeout(() => setIsVisible(true), 50);
    
    const interval = setInterval(() => {
      const remaining = Math.max(0, (hotRollsEndTime - Date.now()) / 1000);
      setTimeLeft(remaining);
      
      if (remaining <= 0) {
        clearInterval(interval);
        setIsVisible(false);
      }
    }, 100);
    
    return () => clearInterval(interval);
  }, [isHotRollsActive, hotRollsEndTime]);
  
  if (!isHotRollsActive) return null;
  
  const progress = (timeLeft / (GAME_CONFIG.HOT_ROLLS_DURATION / 1000)) * 100;
  
  return (
    <div 
      className={`absolute inset-x-0 top-0 z-30 flex justify-center transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}
    >
      <div className="relative mt-2 mx-4 overflow-hidden animate-pulse">
        {/* Жёлтый фон */}
        <img 
          src={hotRollsBg} 
          alt="" 
          className="w-[350px] h-[48px]"
          style={{ filter: 'drop-shadow(0 4px 12px rgba(255, 100, 0, 0.5))' }}
        />
        
        {/* Красная полоска внизу */}
        <img 
          src={hotRollsStripe} 
          alt="" 
          className="absolute bottom-0 left-0 w-[350px] h-[7px]"
        />
        
        {/* Текст HOT ROLLS */}
        <div className="absolute inset-0 flex items-center justify-center">
          <img 
            src={hotRollsText} 
            alt="Hot Rolls!" 
            className="h-[31px]"
          />
        </div>
        
        {/* Таймер */}
        <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1">
          <span className="text-[#8B2500] font-bold text-sm">
            {timeLeft.toFixed(1)}s
          </span>
        </div>
        
        {/* Огоньки по бокам */}
        <div className="absolute left-2 top-1/2 -translate-y-1/2 text-xl animate-bounce">
          🔥
        </div>
        
        {/* Прогресс-бар внизу */}
        <div className="absolute bottom-[7px] left-0 right-0 h-[3px] bg-black/20">
          <div 
            className="h-full bg-white/80 transition-all duration-100 ease-linear"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}

